import {Tabs as AntdTabs} from 'antd';
import './Tabs.module.scss';

const Tabs = ({...props}) => (
  <AntdTabs
    {...props}
  />
);
Tabs.TabPane = AntdTabs.TabPane;
export default Tabs;
